<template>
  <div class="authority_wrap">
    <BreadCrumb crumb="权限管理"></BreadCrumb>
    <div class="top_bar">
      <el-row>
        <el-col :span="8">
          <el-input placeholder="请输入: 权限名称/链接代码" v-model="keyword" class="input-with-select" size="small">
            <el-button slot="append" icon="el-icon-search" @click="fnGetData(1)"></el-button>
          </el-input>
        </el-col>

        <AddAuthor  @fnResetTable="fnGetData(1)"></AddAuthor>

      </el-row>

    </div>
    <PowerTable :authors="aAuthorList" @fnResetTable="fnGetData(1)"></PowerTable>
    <!-- <el-pagination
      background
      layout="prev, pager, next"
      :page-count="pages"
      :current-page="page"
      style="text-align:center;margin-top:10px"
      @current-change="fnGetPage"
      >
    </el-pagination> -->
  </div>
</template>

<script>
import BreadCrumb from '@/components/widget/BreadCrumb'
import AddAuthor from '@/components/widget/AddAuthor'
import PowerTable from '@/components/widget/PowerTable'

import cons from '@/components/constant'

export default {
  name: 'Authority',
  data () {
    return {
      keyword: '',
      page:1,
      pages:8,
      pagesize:10,
      aAuthorList:[]
    }
  },
  components:{
    BreadCrumb,
    AddAuthor,
    PowerTable
  },
  mounted(){
    this.fnGetData(1);
  },
  methods:{
    fnGetData:function(num){
      let token = localStorage.token;
      this.axios.get(cons.apis + '/v1_0/permissions', {
          headers: {
            'Authorization': 'Bearer ' + token
          },
          responseType: 'json',
          params:{
            page:num,
            type: 0,
            order_by: 'id',
            parent_id: 0,
            keyword: this.keyword,
            per_page:this.pagesize
          }
      })
      .then(dat=>{
          this.aAuthorList = dat.data.data.permissions;
          this.page = num;
          this.pages = dat.data.data.total_count
      }).catch(err=>{
         console.log(err);
      });
    },
    fnGetPage:function(dat){
      this.page = dat;
      this.fnGetData(this.page);
    }
  }
}
</script>

<style scoped>
.top_bar{
    width:95.2%;
    overflow:hidden;
    margin:10px auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Power.vue